import type { TextProps } from '@mote/ui'
import { Image, Text } from '@mote/ui'
import styled from '@xstyled/styled-components'

export const StyledImage = styled(Image).attrs({
  alt: 'loop-meme'
})`
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`

export const Header = styled(Text).attrs({
  fontWeight: 500
})<TextProps>({})
